// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2706":"d0b48ef014a5c660","8719":"a84ea6275a3c46e7"}[chunkId] + ".js";
};